export function loadErizo(src) {
  if (typeof window !== "undefined" && window.Erizo) return Promise.resolve(window.Erizo);
  return new Promise((resolve, reject) => {
    const done = (ok, err) => {
      if (window.Erizo) resolve(window.Erizo);
      else reject(err || new Error("erizo.js loaded without Erizo"));
    };
    const existing = document.querySelector('script[data-erizo="1"]');
    if (existing) {
      if (window.Erizo) {
        resolve(window.Erizo);
        return;
      }
      if (existing.dataset.erizoReady === "1") {
        done(false, new Error("erizo.js loaded without Erizo"));
        return;
      }
      existing.addEventListener("load", () => done());
      existing.addEventListener("error", () => reject(new Error("Failed to load erizo.js")));
      setTimeout(() => {
        if (!window.Erizo) reject(new Error("Timed out loading erizo.js"));
      }, 12000);
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.erizo = "1";
    script.onload = () => {
      script.dataset.erizoReady = "1";
      done();
    };
    script.onerror = () => reject(new Error(`Failed to load erizo.js from ${src}`));
    document.head.appendChild(script);
    setTimeout(() => {
      if (!window.Erizo) reject(new Error("Timed out loading erizo.js"));
    }, 12000);
  });
}
